module.exports = __webpack_public_path__ + "img/question-set-questions.a9e2f651.png";